import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './JointAccountHolder.module.scss'
import {
  updateFinancialAccount,
  updateJointOwner,
} from 'utils/apiRequest'
import {
  PERSONAL_INFORMATION,
  IDENTITY_VERIFICATION,
  EMPLOYMENT_DETAILS,
}  from 'utils/accountHolderFormsList'

import FullAccountInformationFormGroup from 'components/Onboarding/FullAccountInformationFormGroup'
import { continueToNextSection, getPreviousSection } from 'utils/financialAccountTypeNavigation'


class JointAccountHolder extends Component {

  constructor (props) {
    super(props)
    this.generateUpdateAccountHandler = this.generateUpdateAccountHandler.bind(this)
    this.getDescription = this.getDescription.bind(this)
    this.getPreviousPage = this.getPreviousPage.bind(this)
    this.goNextPage = this.goNextPage.bind(this)
    this.updateJointOwnerHandler = this.updateJointOwnerHandler.bind(this)
  }

  getDescription (selectedTab) {
    let description
    switch (selectedTab) {
      case PERSONAL_INFORMATION:
        const { openModal } = this.props
        const handleOpenModal = () => {
          openModal('jointAccountHolderInfoModal')
        }
        description = (
          <span className={styles.pageFormDescription}>
           Let’s make sure we have all the info correct for the
            <a onClick={handleOpenModal}> joint holder</a>.
           First, verify some personal information.
          </span>)
        break

      case IDENTITY_VERIFICATION:
        description = (
          <span className={styles.pageFormDescription}>
             Next, we need to validate some identification details.
          </span>
        )
        break

      case EMPLOYMENT_DETAILS:
        description = (
          <span className={styles.pageFormDescription}>
            We’re almost done — the last thing we need are some of your
            joint account holder’s employment details.
          </span>
        )
        break
      default:
        break
    }

    return description
  }

  getJointAccount (financialAccountId) {
    const { jointOwners } = this.props
    return jointOwners && jointOwners.find(jointAccount =>
      jointAccount.financialAccountId === financialAccountId)
  }

  updateJointOwnerHandler (data) {
    const {
      location,
    } = this.props
    const {
      payload: {
        financialAccountId
      }
    } = location
    const jointOwnerID = this.getJointAccount(financialAccountId).data.id
    return updateJointOwner(financialAccountId, jointOwnerID, data)
  }

  generateUpdateAccountHandler (subSection) {
    const { location } = this.props
    const { payload: { financialAccountId } } = location

    return () => {
      const submitData = {
        [`reviewedJoint${subSection}`]: true,
      }
      return updateFinancialAccount(financialAccountId, submitData)
    }
  }

  getPreviousPage () {
    const {
      financialAccounts,
      location: { payload },
      isMobile
    } = this.props
    const {
      financialAccountId,
      financialAccountType,
    } = payload

    return getPreviousSection({
      currentFinancialAccountId: financialAccountId,
      currentFinancialAccountType: financialAccountType,
      currentSection: 'jointOwner',
      financialAccounts,
      jointOwner: true,
      isMobile,
    })
  }

  goNextPage () {
    const { location: { payload }, financialAccounts } = this.props
    const {
      financialAccountId,
      financialAccountType,
    } = payload

    continueToNextSection({
      financialAccounts,
      currentFinancialAccountId: financialAccountId,
      currentFinancialAccountType: financialAccountType,
      currentSection: 'jointOwner',
      jointOwner: true,
    })
  }

  render () {
    const {
      hide,
      isMobile,
      updateJointAccount,
      isLoading,
      location,
      editFinancialAccount,
    } = this.props

    const { payload: { financialAccountId } }  = location
    let jointAccountData = this.getJointAccount(financialAccountId)
    jointAccountData = jointAccountData
     && jointAccountData.data
     && jointAccountData.data.attributes
    const hasJointAccountData = jointAccountData && Object.keys(jointAccountData).length !== 0

    return (
      <FullAccountInformationFormGroup
        account={jointAccountData}
        editFinancialAccount={editFinancialAccount}
        financialAccountId={financialAccountId}
        formName="Joint Account Holder"
        generateUpdateAccountHandler={this.generateUpdateAccountHandler}
        getDescription={this.getDescription}
        handleFinalTab={this.goNextPage}
        hide={hide || !hasJointAccountData}
        isLoading={isLoading}
        isMobile={isMobile}
        isProspect={false}
        prevPageInfo={this.getPreviousPage()}
        setData={updateJointAccount}
        submitAction={this.updateJointOwnerHandler}
        upperTitle="Schwab One &reg; Personal" />
    )
  }

}

JointAccountHolder.propTypes = {
  hide: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  financialAccounts: PropTypes.array.isRequired,
  isMobile: PropTypes.bool.isRequired,
  jointOwners: PropTypes.array.isRequired,
  updateJointAccount: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  editFinancialAccount: PropTypes.func.isRequired,
}

export default JointAccountHolder



// WEBPACK FOOTER //
// ./src/components/Onboarding/Accounts/JointAccountHolder/index.jsx